/* eslint-disable */

import * as d3 from "d3"
import { CrainD3Vis } from "./CrainD3Vis.js"
import { getScale, getColorScale, joinArrayId, createAxis, setScalesAxis, escapeHtml } from './utilities'
import store from '@/store/store'

class GeneralChartControl extends CrainD3Vis {
    /**
     *
     * @param svg: svg where HeatMapControl needs to be made
     * @param cd: CrainData object that contains data for visualization
     */
    constructor(svg, cd, svgDiv, limit = false) {
        super(svg, cd, svgDiv, limit);
        this.selectClass = 'datarect';
        this.dataInterpolator = undefined;
        this.dataScale = undefined;
        this.dataLabel = undefined;
        this.dataLoc = undefined;
        this.xScale = undefined; // If width needs to be determined
        this.yScale = undefined; // if height needs to be determined
        this.config = {
            color: "size",
            metric: "size",
            onX: undefined, // Create xScale on this (eg. size, recency, ...)
            onY: undefined, // Create ySCale on this (eg. size, recency, ...)
            height: undefined, // Whether and if height needs to determined
            normOverX: false,
            xShift: 10,
            yShift: 8,
            yLabelsWidth: 250,
            xLabelsHeight: 200,
            normalRectWidth: 30,
            normalRectHeight: 30,
            minRectWidth: 8,
            minRectHeight: 8,
            normalGraphWidth: 900,
            normalGraphHeight: 600
        };
        this.layout = {
            xShifts: undefined,
            yShifts: undefined,
            xShift: undefined,
            yShift: undefined,
            totalXShift: undefined,
            totalYShift: undefined,
            graphWidth: undefined,
            graphHeight: undefined,
            svgWidth: this.svgDiv ? document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetWidth : undefined,
            svgHeight: this.svgDiv ? document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetHeight : undefined,
            rectBorder: undefined,
            rectWidth: undefined,
            rectHeight: undefined,
            width: undefined,
            height: undefined,
            yLabelsWidth: undefined,
            xLabelsHeight: undefined,
            responsive: document.getElementById(this.svgDiv.split(" ")[0].slice(1)).getAttribute("layout")
        };
        this.controlNormalFormatting = this.controlNormalFormatting.bind(this);
        this.controlSelectFormatting = this.controlSelectFormatting.bind(this);
    }

    /**
     * Perform formatting when in normal modus
     * @param selection: d3 selection of groups contraining rects
     */
    controlNormalFormatting(selection) {
        selection.select('rect').attr('fill', d => d.data ?
            this.dataInterpolator(this.dataScale((this.config.normOverX ? 1 + d[this.dataLoc][this.dataLabel] / this.crainData.dataNormX[d.y] : d[this.dataLoc][this.dataLabel]))) : 'lightgray')
    }

    /**
     * Perform formatting when in selection modus
     * @param selection: d3 selection of groups contraining rects
     */
    controlSelectFormatting(selection) {
        if (this.crainData.selected.size > 0) {
            //selection.select('rect').attr('fill', d => d.selected ?#2FFFE7
            //    this.dataInterpolator(this.dataScale((this.config.normOverX ? 1 + d[this.dataLoc][this.dataLabel] / this.crainData.dataNormX[d.y] : d[this.dataLoc][this.dataLabel]))) : 'lightgray')
            //selection.select('rect').attr('fill', d => d.selected ? '#2FFFE7':'lightgray')
            selection.select('rect').attr('fill', d => d.selected ? '#333333':'lightgray')
    

        } else {
            selection.call(this.controlNormalFormatting)

        }

    }

    /**
     * Calculate movements of rect
     * @param d: data
     * @param c: count
     * @returns {string} transform string
     */
    calculateRectTransform(d, c) {
        return 'translate(' + ((d.x * this.layout.rectWidth) + (this.layout.xShifts[d.x] * this.layout.xShift)) + ',' + ((d.y * this.layout.rectHeight) + (this.layout.yShifts[d.y] * this.layout.yShift)) + ')'
    }

    /**
     * Calculate group shifts if necessary
     * @param layers
     * @returns {[]}
     */
    calculateShifts(layers) {
        let sizes = [];
        let ref;
        for (let layer of layers) {
            if (ref) {
                let cnt = sizes.slice(-1)[0];
                for (let c = 0; c < ref.length; c++) {
                    if (c !== ref.length - 1) { // Last item is ignored, is normally always different, but remains to be with the same cluster
                        let rId = ref[c] ? ref[c]._id : null;
                        let lId = layer[c] ? layer[c]._id : null;
                        if (lId !== rId) { cnt += 1 }
                    }
                }
                sizes.push(cnt);
            } else {
                sizes.push(0);
            }
            ref = layer;
        }
        return sizes;
    }

    /**
     * Get scales corresponding with settings, and select coloring interpolator
     */
    setScale() {
        // ColorScale
        let colorScale;
        if (["recency", "relrecency", "relsize", "linked", "filtrecency"].includes(this.config.color)) {
            this.config.normOverX = false; // No normalization over X on recency
            colorScale = getColorScale(this.config.color + "_linear", this.crainData.processedData);
        } else if (["size", "origsize", "filtsize"].includes(this.config.color)) {
            // Data Cleaning
            colorScale = getColorScale(this.config.color + "_log", this.crainData.processedData);
            if (this.config.normOverX) {
                // Domain by normalization (log) => [0+1,1+1] = [1,2]
                colorScale.scale.domain([1, 2])
            }
        }

        this.dataScale = colorScale.scale;
        this.dataInterpolator = colorScale.interpolator;
        this.dataLabel = colorScale.dataLabel;
        if (["recency", "size", "origsize"].includes(this.config.color)) {
            this.dataLoc = "data"
        } else {
            this.dataLoc = "filtdata"
        }

        // DataScale
        if (this.config.onX) {
            this.xScale = getScale(this.config.onX, this.crainData.processedData);
            this.xScale.scale.range([0, this.layout.graphWidth]);
        }
        if (this.config.onY) {
            this.yScale = getScale(this.config.onY, this.crainData.processedData);
            this.yScale.scale.range([0, this.layout.graphHeight]);
        }
    }


    /**
     * Calculations of layout
     */
    layoutCalculations() {
        //console.log(this.layout.svgWidth, this.layout.svgHeight);
        let cd = this.crainData;
        this.responsive = this.layout.responsive;
        // Determine direction shifts to create subgroups if sorting is normal ()
        this.layout.xShifts = cd.sort_X !== "normal" ? Array(cd.xLayers.length).fill(0) : this.calculateShifts(cd.xLayers);
        this.layout.yShifts = cd.sort_Y !== "normal" ? Array(cd.yLayers.length).fill(0) : this.calculateShifts(cd.yLayers);
        if (this.layout.svgWidth && this.layout.svgHeight && this.responsive) {
            this.layout.width = this.layout.svgWidth;
            this.layout.height = this.layout.svgHeight;

            this.layout.yLabelsWidth = 0.2 * this.layout.width;
            this.layout.graphWidth = 0.8 * this.layout.width;
            this.layout.xLabelsHeight = 0.2 * this.layout.height;
            this.layout.graphHeight = 0.8 * this.layout.height;

            let nXShifts = Math.max(...this.layout.xShifts);
            let nYShifts = Math.max(...this.layout.yShifts);

            this.layout.totalXShift = Math.min(0.05 * this.layout.graphWidth, nXShifts * this.config.xShift);
            this.layout.totalYShift = Math.min(0.05 * this.layout.graphHeight, nYShifts * this.config.yShift);

            this.layout.xShift = nXShifts ? this.layout.totalXShift / nXShifts : 0;
            this.layout.yShift = nYShifts ? this.layout.totalYShift / nYShifts : 0;

            let allRectWidths = this.layout.graphWidth - this.layout.totalXShift;
            let allRectHeights = this.layout.graphHeight - this.layout.totalYShift;

            this.layout.rectWidth = allRectWidths / cd.xLayers.length;
            this.layout.rectHeight = allRectHeights / cd.yLayers.length;

        } else {
            this.layout.xShift = this.config.xShift;
            this.layout.yShift = this.config.yShift;

            this.layout.totalXShift = Math.max(...this.layout.xShifts) * this.config.xShift;
            this.layout.totalYShift = Math.max(...this.layout.yShifts) * this.config.yShift;

            this.layout.rectWidth = Math.min(Math.max(this.config.normalGraphWidth / cd.xLayers.length, this.config.minRectWidth), this.config.normalRectWidth);
            this.layout.rectHeight = Math.min(Math.max(this.config.normalGraphHeight / cd.yLayers.length, this.config.minRectHeight), this.config.normalRectHeight);

            this.layout.graphWidth = (this.layout.rectWidth * cd.xLayers.length) + this.layout.totalXShift;
            this.layout.graphHeight = (this.layout.rectHeight * cd.yLayers.length) + this.layout.totalYShift;

            this.layout.xLabelsHeight = this.config.xLabelsHeight;
            this.layout.yLabelsWidth = this.config.yLabelsWidth;

            this.layout.width = this.layout.yLabelsWidth + this.layout.graphWidth;
            this.layout.height = this.layout.xLabelsHeight + this.layout.graphHeight;

            
        }
        this.svg.attr('width', this.layout.width);
        this.svg.attr('height', this.layout.height);
        this.layout.rectBorder = 0.05 * this.layout.rectHeight;

    }

    /**
     *
     * @param g: maingroup in svg (g#main)
     */
    drawMainGroups(g) {
        let graphSpace = g.select('g#graph');

        if (graphSpace.empty()) {
            graphSpace = g.append('g').attr('id', 'graph');
            graphSpace.append('g').attr('id', 'graphback');
            graphSpace.append('g').attr('id', 'graphrects');
        }
        graphSpace.attr('transform', 'translate(' + this.layout.yLabelsWidth + ',0)');
    }

    /**
     * Draw textLabels for axis
     * @param g: maingroup in svg (g#main)
     */
    drawLabels(g) {
        let cd = this.crainData;
        let ySpace = g.select('g#ySpace');
        let xSpace = g.select('g#xSpace');
        if (ySpace.empty()) { ySpace = g.append('g').attr('id', 'ySpace'); }
        if (xSpace.empty()) { xSpace = g.append('g').attr('id', 'xSpace'); }
        xSpace.attr('transform', 'translate(0,' + this.layout.graphHeight + ')');

        // Get required labels from sorter
        let gXLabels = xSpace.selectAll('g.xlabels').data(cd.xLayers, d => d.map(el => el ? el._id : "allid").join("-"));
        let gYLabels = ySpace.selectAll('g.ylabels').data(cd.yLayers, d => d.map(el => el ? el._id : "allid").join("-"));

        // Labels
        gXLabels.exit().remove();
        gYLabels.exit().remove();
        let newGXLabels = gXLabels.enter().append('g')
            .attr('class', 'xlabels');

        let newGYLabels = gYLabels.enter().append('g')
            .attr('class', 'ylabels');

        newGXLabels.append('text')
            .attr('fill', 'black')
            .attr('text-anchor', 'end')
            .attr('font-size', 8)
            .attr('stroke', '#005c7e')
            .attr('stroke-width', '0.2px')
            .on('mouseover', function() {
                d3.select(this).attr('font-weight', 'bold')
                    .attr('font-size', 13)
                    .attr('stroke', 'black')
                    .attr('stroke-width', '0.3px')
            })
            .on('mouseout', function() {
                d3.select(this).attr('font-weight', 'normal')
                    .attr('font-size', 8)
                    .attr('stroke', '#005c7e')
                    .attr('stroke-width', '0.2px')
            });

        let xSorter = this.crainData.xSorter;
        let ySorter = this.crainData.ySorter;
        newGXLabels.merge(gXLabels)
            .attr('id', (d, c) => "xlab_" + xSorter[c])
            .attr('transform', (d, c) => 'translate(' + (this.layout.yLabelsWidth + ((c + 0.5) * this.layout.rectWidth) + (this.layout.xShifts[c] * this.layout.xShift)) + ',' + this.layout.rectHeight + ')rotate(-45)')
            .select('text')
            .text(d => joinArrayId(d));

        newGYLabels.append('text')
            .attr('id', (d, c) => "ylab_" + ySorter[c])
            .attr('fill', 'black')
            .attr('text-anchor', 'end')
            .attr('font-size', 8)
            .attr('stroke', '#005c7e')
            .attr('stroke-width', '0.2px')
            .on('mouseover', function() {
                d3.select(this).attr('font-weight', 'bold')
                    .attr('font-size', 13)
                    .attr('stroke', 'black')
                    .attr('stroke-width', '0.3px')
            })
            .on('mouseout', function() {
                d3.select(this).attr('font-weight', 'normal')
                    .attr('font-size', 8)
                    .attr('stroke', '#005c7e')
                    .attr('stroke-width', '0.2px')
            });

        newGYLabels.merge(gYLabels)
            .attr('transform', (d, c) => 'translate(' + (this.layout.yLabelsWidth - 5) + ',' + (((c + 0.5) * this.layout.rectHeight) + (this.layout.yShifts[c] * this.layout.yShift)) + ')')
            .select('text')
            .text(d => joinArrayId(d))
            .attr('alignment-baseline', 'middle');

    }

    /**
     * Draw Rects corresponding with data
     * @param g: maingroup in svg (g#main)
     */
    drawRects(g) {
        // Data Preprocess
        let svgDiv = this.svgDiv;
        let graphRects = g.select('g#graphrects');
        let cd = this.crainData;
        
        let gRects = graphRects.selectAll('g.' + this.selectClass)
            .data(cd.processedData.filter(d => d.filtdata ? d.filtdata.size !== 0 : true), d => d.id);

        // Heatmap
        gRects.exit().remove();
        let newGRects = gRects.enter().append('g')
            .attr('class', this.selectClass);

        newGRects.append('rect')
            .attr('stroke', 'white');

        newGRects.merge(gRects)
            //Diff
            .attr('transform', (d, c) => this.calculateRectTransform(d, c))
            //NoDiff
            .call(this.controlDataPointFormatting)
            .on('mouseover', function(d, c) {
                //console.log(d);
                d3.select(svgDiv + ' #xlab_' + d.orig_x).attr('font-weight', 'bold');
                d3.select(svgDiv + ' #ylab_' + d.orig_y).attr('font-weight', 'bold');
                d3.select('#hoverDiv')
                    .style('opacity', 0.9)
                    .style('top', event.clientY + 10 + 'px')
                    .style('left', event.clientX + 10 + 'px')
                    .html(`
                        <strong>${joinArrayId(cd.xLayers[d.x])}</strong><br>
                        <strong>${joinArrayId(cd.yLayers[d.y])}</strong><br>
                        <strong>(${cd.zLayersBase[cd.z] ? joinArrayId(cd.zLayersBase[cd.z]): "All"})</strong><br>
                        Period: ${cd.rawData.meta.startyear}-${cd.rawData.meta.recentyear}-${cd.rawData.meta.stopyear}<br>
                        Size: ${d.filtdata? d.filtdata.size:d.data.origsize}<br>
                        Recency: ${d.filtdata? d.filtdata.recency:d.data.recency}<br>
                        Origsize: ${d.data.origsize} (${cd.rawData.meta.poolstart}-${cd.rawData.meta.poolstop})
                    `)
            })
            .on('mouseout', (d) => {
                d3.select(this.svgDiv + ' #xlab_' + d.orig_x).attr('font-weight', 'normal');
                d3.select(this.svgDiv + ' #ylab_' + d.orig_y).attr('font-weight', 'normal');
                d3.select('#hoverDiv')
                    .style('opacity', 0);
            })
            .select('rect')
            .attr('width', this.layout.rectWidth || (d => this.xScale.scale(d[this.xScale.location][this.xScale.field])))
            .attr('height', this.layout.rectHeight || (d => this.yScale.scale(d[this.yScale.location][this.yScale.field])))
            .attr('stroke-width', this.layout.rectBorder);

    }

    /**
     * Draw spacings between different groups
     * @param g: maingroup in svg (g#main)
     */
    drawSeparators(g) {
        // Separators
        let graphBack = g.select('g#graphback');
        graphBack.selectAll('.separators').remove();
        let xShift = this.layout.xShift;
        let yShift = this.layout.yShift;
        let shiftMargin = 10; // Additional margin for divisions
        this.layout.yShifts.forEach((d, c) => {
            if (c > 0) {
                if (this.layout.yShifts[c] !== this.layout.yShifts[c - 1]) {
                    let ypos = ((c * this.layout.rectHeight) + (d - 0.5) * yShift);
                    let shiftHeight = 2;
                    // Opaque rect for divisions
                    graphBack.append('rect').attr('class', 'separators')
                        .attr('x', shiftMargin).attr('y', ypos).attr('height', shiftHeight).attr('width', this.layout.graphWidth - 2 * shiftMargin)
                        .style('opacity', 0.05).style('fill', '#004482');
                }
            }
        });
        this.layout.xShifts.forEach((d, c) => {
            if (c > 0) {
                if (this.layout.xShifts[c] !== this.layout.xShifts[c - 1]) {
                    let xpos = ((c * this.layout.rectWidth) + (d - 0.5) * xShift);
                    let shiftWidth = 2;
                    let shiftWidthExt = 25;
                    // Draw a white rect for interruption effect
                    graphBack.append('rect').attr('class', 'separators')
                        .attr('x', xpos - shiftWidthExt / 2).attr('y', shiftMargin).attr('width', shiftWidthExt).attr('height', this.layout.graphHeight - 2 * shiftMargin)
                        .style('opacity', 1).style('fill', 'white');
                    // Opaque rect for divisions
                    graphBack.append('rect').attr('class', 'separators')
                        .attr('x', xpos - shiftWidth / 2).attr('y', shiftMargin).attr('width', shiftWidth).attr('height', this.layout.graphHeight - 2 * shiftMargin)
                        .style('opacity', 0.05).style('fill', '#004482');

                }
            }
        });
    }

    /**
     * Redraw visualization
     * @param reset: if true, restart from scratch
     */
    update(reset = false, cType = null) {

        if (cType === 'barchart') {
            this.config.onX = this.config.metric;
        }

        if (
          cType === 'columnchart' ||
          cType === 'linechart'
        ) {
            this.config.onY = this.config.metric;
        }

        this.layoutCalculations();
        
        if (reset) {
            console.log("Clearing svg for redraw");
            this.svg.selectAll('g#main').remove();
        }

        let g = this.svg.select('g#main');
        if (g.empty()) { g = this.svg.append('g').attr('id', 'main') }

        this.drawMainGroups(g);
        this.setScale();
        this.drawSeparators(g);
        this.drawRects(g);
        this.drawLabels(g);
        this.controlSelect();
        
        //setTimeout(() => {
        //    store.dispatch('loadAnimEnd');
        //}, 6000);
        //this.svg.select('g#main text#temp-text').remove();
        store.dispatch('saveLoadingStep', "Complete");

    }
}

/**
 *  OneDHeatmapControl controls a OneDimensional heatmap, meaning that only
 */
class OneDHeatMapControl extends GeneralChartControl {
    /**
     *
     * @param svg: svg where OneDHeatMap needs to be
     * @param cd: CrainData element containing the data
     */
    constructor(svg, cd, svgDiv) {
        super(svg, cd, svgDiv);
        this.layout.yLabelsWidth = 0;
        this.layout.xNumber = undefined; // Number of rects on x-axis
        this.layout.yNumber = undefined; // Number of rects on y-axis
    }

    calculateRectTransform(d, c) {
        return 'translate(' + (d.x % this.layout.xNumber) * this.layout.rectWidth + ',' + ~~(d.x / this.layout.xNumber) * this.layout.rectHeight + ')'; // ~~ binary operation to floor division
    }

    drawLabels(g) {
        // Empty - no labels need to be drawn
    }

    drawSeparators(g) {
        // Empty - no separators need to be drawn
    }


    layoutCalculations() {
        let cd = this.crainData;
        this.responsive = this.layout.responsive;
        if (this.layout.svgWidth && this.layout.svgHeight && this.responsive) {
            this.layout.width = this.layout.svgWidth;
            this.layout.height = this.layout.svgHeight;

            this.layout.graphWidth = this.layout.width;
            this.layout.graphHeight = this.layout.height;

            let base = (cd.xLayers.length / (this.layout.width * this.layout.height)) ** 0.5;
            this.layout.xNumber = Math.floor(base * this.layout.width);
            this.layout.yNumber = Math.ceil(base * this.layout.height);
            if (this.layout.xNumber * this.layout.yNumber < cd.xLayers.length) {
                let diff = cd.xLayers.length - (this.layout.xNumber * this.layout.yNumber);
                if (diff < this.layout.xNumber) {
                    this.layout.yNumber += 1;
                } else {
                    this.layout.yNumber += 2;
                }
            }

            this.layout.rectWidth = this.layout.graphWidth / this.layout.xNumber;
            this.layout.rectHeight = this.layout.graphHeight / this.layout.yNumber;

            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height);

        } else {
            // 16:9 formatting: xLayers = 16x * 9x <=> xLayers / (16 * 9) = x^2 <=> (xLayers / (16 * 9))^0.5 = x
            let base = (cd.xLayers.length / (16 * 9)) ** 0.5;
            this.layout.xNumber = Math.floor(base * 16);
            this.layout.yNumber = Math.ceil(base * 9);

            this.layout.rectWidth = Math.min(Math.max(this.config.normalGraphWidth / this.layout.xNumber, this.config.minRectWidth), this.config.normalRectWidth);
            this.layout.rectHeight = Math.min(Math.max(this.config.normalGraphHeight / this.layout.yNumber, this.config.minRectHeight), this.config.normalRectHeight);

            this.layout.graphWidth = (this.layout.rectWidth * this.layout.xNumber);
            this.layout.graphHeight = (this.layout.rectHeight * this.layout.yNumber);

            this.layout.width = this.layout.graphWidth;
            this.layout.height = this.layout.graphHeight;

            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height);
        }

        this.layout.rectBorder = 0.05 * this.layout.rectHeight;

    }
}

class BarChartControl extends GeneralChartControl {
    /**
     *
     * @param svg: svg where BarChartControl needs to be
     * @param cd: CrainData element containing the data
     */
    constructor(svg, cd, svgDiv, limit) {
        super(svg, cd, svgDiv, limit);
        this.config.onX = "size_linear";
        this.config.minRectHeight = 18;
        this.config.topHeight = 30;
    }

    calculateRectTransform(d, c) {
        return 'translate(0,' + (d.x * this.layout.rectHeight + this.layout.topHeight) + ')';
    }

    drawAxes(g) {
        let axX = createAxis(this, g, true);
        let gXAxis = axX[0];
        let gXAxisLabel = axX[1];
        setScalesAxis(this, g, false, false, false);
        gXAxis.attr('transform', 'translate(' + this.layout.yLabelsWidth + ',' + (this.layout.topHeight - 5) + ')');
        gXAxisLabel.attr('transform', 'translate(' + (this.layout.yLabelsWidth + this.layout.graphWidth / 2) + ',' +
            (this.layout.topHeight - 20) + ')');
    }

    drawLabels() {
        // Here labels are drown upon text elements
        let gRects = this.svg.selectAll('g.' + this.selectClass);

        // Get correct labels
        // let xLabs = this.crainData.xSorter.map(d => {console.log(d); return this.crainData.xLayers[d]});

        gRects.selectAll('text').remove();
        gRects.append('text')
            .attr('id', (d, c) => "xlab_" + d.orig_x)
            .attr('transform', (d) => 'translate(-10,' + 0.5 * this.layout.rectHeight + ')')
            .attr('fill', 'black')
            .attr('stroke', 'gray')
            .attr('stroke-width', '0.4px')
            .attr('text-anchor', 'end')
            .attr('alignment-baseline', 'middle')
            .attr('font-size', 12)
            .text(d => this.crainData.xLayers[d.x].map(el => el ? el.name : "All").join("-").length > 15?
                this.crainData.xLayers[d.x].map(el => el ? el.name : "All").join("-").substring(0, 15) + "...\t(" + d[this.xScale.location][this.xScale.field] + ")"
                :this.crainData.xLayers[d.x].map(el => el ? el.name : "All").join("-") + "\t(" + d[this.xScale.location][this.xScale.field] + ")");
    }

    drawSeparators(g) {
        // Empty - no separators need to be drawn
    }

    /**
     * Calculations of layout
     */
    layoutCalculations() {
        let cd = this.crainData;
        this.responsive = this.layout.responsive;
        //if (this.layout.svgWidth && this.layout.svgHeight && this.responsive) {
            this.layout.width = this.layout.svgWidth;
            this.layout.height = this.layout.svgHeight;

            this.layout.yLabelsWidth = 0.4 * this.layout.width;
            this.layout.graphWidth = 0.6 * this.layout.width;
            this.layout.graphHeight = this.layout.height - this.config.topHeight;
            this.layout.topHeight = this.config.topHeight;
            this.layout.rectHeight = this.layout.graphHeight / cd.xLayers.length;
            if (this.layout.rectHeight < this.config.minRectHeight) {
                this.layout.rectHeight = this.config.minRectHeight;
                this.layout.height = this.config.minRectHeight * cd.xLayers.length;
                this.layout.width -= 20;
            }
            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height + 60);
        /*} else {
            this.layout.rectHeight = Math.min(Math.max(this.config.normalGraphHeight / cd.xLayers.length, this.config.minRectHeight), this.config.normalRectHeight);
            this.layout.topHeight = this.config.topHeight;
            this.layout.graphWidth = this.config.normalGraphWidth;
            this.layout.graphHeight = (this.layout.rectHeight * cd.xLayers.length);
            this.layout.yLabelsWidth = this.config.yLabelsWidth;

            this.layout.width = this.layout.yLabelsWidth + this.layout.graphWidth;
            this.layout.height = this.layout.graphHeight + this.layout.topHeight;

            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height);
        }*/
        this.layout.rectWidth = undefined;
        this.layout.rectBorder = 0.05 * this.layout.rectHeight;
    }

    update(reset = false, type = null) {
        super.update(reset, type);
        let g = this.svg.select('g#main');
        this.drawAxes(g);
    }
}

class ColumnChartControl extends GeneralChartControl {
    /**
     *
     * @param svg: svg where ColumnChartControl needs to be
     * @param cd: CrainData element containing the data
     */
    constructor(svg, cd, svgDiv) {
        super(svg, cd, svgDiv);
        this.config.onY = "size_linear";
        this.config.minRectWidth = 18;
        this.config.yLabelsWidth = 100;
    }

    calculateRectTransform(d, c) {
        return 'translate(' + d.x * this.layout.rectWidth + ', 0)';
    }

    drawAxes(g) {

        let axY = createAxis(this, g, false);
        let gYAxis = axY[0];
        let gYAxisLabel = axY[1];
        setScalesAxis(this, g, false, true);
        gYAxis.attr('transform', 'translate(' + (this.layout.yLabelsWidth - 2) + ',0)');
        gYAxisLabel.attr('transform', 'translate(' + (this.layout.yLabelsWidth - 50) + ',' + this.layout.graphHeight / 2 + ')');
    }

    drawLabels() {
        // Here labels are drown upon text elements
        let gRects = this.svg.selectAll('g.' + this.selectClass);
        let xSorter = this.crainData.xSorter;
        gRects.selectAll('text').remove();
        gRects.append('text')
            .attr('id', (d, c) => "xlab_" + d.orig_x)
            .attr('transform', (d) => 'translate(10,' + (0.5 * this.layout.rectWidth) + ')')
            .attr('fill', 'black')
            .attr('stroke', 'gray')
            .attr('stroke-width', '0.4px')
            .attr('text-anchor', 'end')
            .attr('alignment-baseline', 'middle')
            .attr('font-size', 12)
            .text(d => this.crainData.xLayers[d.x].map(el => el ? el.name : "All").join("-") + "\t(" + d[this.yScale.location][this.yScale.field] + ")")
            .attr('transform', 'translate(' + (this.layout.rectWidth / 2) + "," + (this.layout.graphHeight + 10) + ') rotate(-45)');

    }

    drawSeparators(g) {
        // Empty - no separators need to be drawn
    }

    /**
     * Calculations of layout
     */
    layoutCalculations() {
        let cd = this.crainData;
        this.responsive = this.layout.responsive;
        //if (this.layout.svgWidth && this.layout.svgHeight && this.responsive) {
            this.layout.width = this.layout.svgWidth;
            this.layout.height = this.layout.svgHeight;

            this.layout.yLabelsWidth = 0.1 * this.layout.width;
            this.layout.graphWidth = 0.9 * this.layout.width;
            this.layout.graphHeight = 0.6 * this.layout.height;
            this.layout.xLabelsHeight = 0.4 * this.layout.height;

            this.layout.rectWidth = this.layout.graphWidth / cd.xLayers.length;
            if (this.layout.rectWidth < this.config.minRectWidth) {
                this.layout.rectWidth = this.config.minRectWidth;
                this.layout.width = this.config.minRectWidth * cd.xLayers.length;
                this.layout.height -= 10;
            }
            this.svg.attr('width', this.layout.width + 60);
            this.svg.attr('height', this.layout.height);
        /*} else {

            this.layout.rectWidth = Math.min(Math.max(this.config.normalGraphWidth / cd.xLayers.length, this.config.minRectWidth), this.config.normalRectWidth);

            this.layout.graphWidth = (this.layout.rectWidth * cd.xLayers.length);
            this.layout.graphHeight = this.config.normalGraphHeight;

            this.layout.yLabelsWidth = this.config.yLabelsWidth;
            this.layout.xLabelsHeight = this.config.xLabelsHeight;
            this.layout.width = this.layout.yLabelsWidth + this.layout.graphWidth;
            this.layout.height = this.layout.graphHeight + this.layout.xLabelsHeight;
            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height);
        }*/
        this.layout.rectHeight = undefined;
        this.layout.rectBorder = 0.05 * this.layout.rectWidth;
    }

    /**
     * Draw Rects corresponding with data
     * @param g: maingroup in svg (g#main)
     */
    drawRects(g) {
        // Data Preprocess
        let svgDiv = this.svgDiv;
        let graphRects = g.select('g#graphrects');
        let cd = this.crainData;
        let gRects = graphRects.selectAll('g.' + this.selectClass).data(cd.processedData, d => d.id);

        // Heatmap
        gRects.exit().remove();
        let newGRects = gRects.enter().append('g')
            .attr('class', this.selectClass);

        newGRects.append('rect')
            .attr('stroke', 'white');

        newGRects.merge(gRects)
            //Diff
            .attr('transform', (d, c) => this.calculateRectTransform(d, c))
            //NoDiff
            .call(this.controlDataPointFormatting)
            .on('mouseover', function(d, c) {
                d3.select(svgDiv + ' #xlab_' + d.orig_x).attr('font-weight', 'bold');
                d3.select('#hoverDiv')
                    .style('opacity', 0.9)
                    .style('top', event.clientY + 10 + 'px')
                    .style('left', event.clientX + 10 + 'px')
                    .html(`
                        <strong>${joinArrayId(cd.xLayers[d.x])}</strong><br>
                        <strong>${joinArrayId(cd.yLayers[d.y])}</strong><br>
                        <strong>(${cd.zLayersBase[cd.z] ? joinArrayId(cd.zLayersBase[cd.z]): "All"})</strong><br>
                        Period: ${cd.rawData.meta.startyear}-${cd.rawData.meta.recentyear}-${cd.rawData.meta.stopyear}<br>
                        <br>
                        Size: ${d.filtdata? d.filtdata.size:d.data.origsize}<br>
                        Recency: ${d.filtdata? d.filtdata.recency:d.data.recency}<br>
                        Origsize: ${d.data.origsize} (${cd.rawData.meta.poolstart}-${cd.rawData.meta.poolstop})
                    `)
            })
            .on('mouseout', (d) => {
                d3.select('#hoverDiv')
                    .style('opacity', 0);
                d3.select(this.svgDiv + ' #xlab_' + d.orig_x).attr('font-weight', 'normal');
            })
            .select('rect')
            .attr('width', this.layout.rectWidth)
            .attr('height', d => this.yScale.scale(d[this.yScale.location][this.yScale.field]))
            .attr('stroke-width', this.layout.rectBorder)
            .attr('transform', d => 'translate(0, ' + (this.layout.graphHeight - this.yScale.scale(d[this.yScale.location][this.yScale.field])) + ')');



    }

    update(reset = false, type = null) {
        super.update(reset, type);
        let g = this.svg.select('g#main');
        this.drawAxes(g);
    }
}

class TableControl extends GeneralChartControl {
    /**
     *
     * @param svg: svg where TableControl needs to be
     * @param cd: CrainData element containing the data
     */
    constructor(svg, cd, svgDiv) {
        super(svg, cd, svgDiv);
    }

    setScale() {
        // Do nothing
    }

    drawTextLabels() {
        // Here labels are drown upon text elements
    }

    drawSeparators(g) {
        // Empty - no separators need to be drawn
    }

    drawLabels(g) {
        // Empty - no X - Y need to be drawn
    }

    /**
     * Draw Rects corresponding with data
     * @param g: maingroup in svg (g#main)
     */
    drawRects(g) {
        // Empty
    }

    update(reset = false) {
        super.update(reset);

        if (reset) {
            this.svg.selectAll('g#main').remove();
        }

        let g = this.svg.select('g#main');
        if (g.empty()) { g = this.svg.append('g').attr('id', 'main') }

        this.drawSeparators();
        this.drawRects();
        this.drawLabels();
        this.drawTextLabels();
    }

}

export { GeneralChartControl, OneDHeatMapControl, BarChartControl, ColumnChartControl, TableControl }
